<template>
  <tr>
    <td>{{name}}</td>
    <td><slot /></td>
  </tr>
</template>


<script>
export default {
  name: 'PropertyValueRow',
  props: {
    name: String
  }
}
</script>